import { useEffect, useState, useRef } from 'react';
import Map from '@/components/atoms/map/map';
import Campus from '@/components/molecules/de-uni/campus/campus';
import ICampus from '@/models/viewModels/ICampus';
import { Breakpoint, useWindowResize } from '@into-discovery/browsewebshared';
import { deviceDetect } from '@into-discovery/browsewebshared/src/data/device-detect';
import styles from './campuses.module.scss';

type Props = {
  campuses: ICampus[];
  universityName: string;
  universityPrimaryColor: string;
  mapsApiKey: string;
};

export default function Campuses({
  campuses,
  mapsApiKey,
  universityName,
  universityPrimaryColor,
}: Props) {
  const [isBreakpointUp, setIsBreakpointUp] = useState(!deviceDetect.isMobile);

  useWindowResize((newWidth) => setIsBreakpointUp(newWidth >= Breakpoint.Large), 100);

  const [mapLocation, setMapLocation] = useState(null);
  const mapRef = useRef(null);
  const [mapError, setMapError] = useState(false);

  const mapOptions = {
    streetViewControl: false,
    mapTypeControl: false,
    styles: [
      {
        featureType: `poi`,
        stylers: [{ visibility: `off` }],
      },
    ],
  };

  useEffect(() => {
    const coordinates = {
      lat: campuses[0].coordinates.latitude,
      lng: campuses[0].coordinates.longitude,
    };
    setMapLocation(coordinates);
  }, [campuses]);

  const onChangeCampus = (position) => {
    mapRef.current.scrollIntoView({ behavior: `smooth` });
    setMapLocation(position);
  };

  const resetMapLocation = () => {
    setMapLocation(null);
  };

  return (
    <section className="mt-5" id="university-campuses">
      <h2>Campus and location</h2>
      <div ref={mapRef}>
        {universityName && <h3>{universityName} campuses</h3>}
        {!mapError ? (
          <div className={`${styles[`campus-location`]}`}>
            <Map
              resetLocation={resetMapLocation}
              coordinates={mapLocation}
              height={isBreakpointUp ? `480px` : `315px`}
              apiKey={mapsApiKey}
              onMapError={setMapError}
              options={mapOptions}
            />
          </div>
        ) : null}
        {campuses &&
          campuses.map((campus) => (
            <Campus
              key={campus.campusId}
              campus={campus}
              onChangeCampus={onChangeCampus}
              brandColor={universityPrimaryColor}
              disableAddressLink={mapError}
            />
          ))}
      </div>
    </section>
  );
}
